var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "doc-change-by-credit-note",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.$t.__("documents.DocChangeByCreditNote.edit_credit_note")
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("update:visible", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c("div", { staticClass: "dialog__default" }, [
              _c(
                "p",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Vous allez modifier cette facture par la création d'un avoir et d'une autre facture."
                        )
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$l10n.__(
                          "L'avoir va se créer automatiquement et vous serez ensuite redirigé vers la nouvelle facture."
                        )
                      ) +
                      "\n            "
                  )
                ]
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("update:visible", false)
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__(
                      "documents.DocChangeByCreditNote.create_credit_note_and_invoice"
                    ),
                    type: "primary",
                    loading: _vm.loading
                  },
                  on: { click: _vm.cancel }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }